import home from './modules/home';
// import alliance from './modules/alliance1111';
import chainmaker from './modules/chainmaker';
import BasicLayout from '@/layouts/basic-layout';
import setting from './modules/setting'
import basic from './modules/basic'
import super1 from './modules/super'
import carbon from './modules/carbon'
import bcos from "./modules/bcos/home"
import bcosChain from "./modules/bcos/chain"
import bcosContract from "./modules/bcos/contract"
import bcosSystem from "./modules/bcos/system"
import bcosMonitor from "./modules/bcos/monitor"
import bcosAudit from "./modules/bcos/audit"
import BcosEvent from "./modules/bcos/event"

import FiscoBcos from './modules/fisco-bcos'  // Fisco

// 财务报表
import report from "./modules/report"

/**
 * 在主框架内显示
 */

const frameIn = [
    {
        path: '/chain',
        redirect: {
            name: 'chain-explorer'
        },
        component: BasicLayout,
        children: [
            {
                path: 'explorer',
                name: 'explorer',
                redirect: {
                    name: 'chain-explorer'
                }
            },
            // {
            //     path: 'log',
            //     name: 'log',
            //     meta: {
            //         title: '前端日志',
            //         auth: true
            //     },
            //     component: () => import('@/pages/system/log')
            // },
            // 刷新页面 必须保留
            {
                path: 'refresh',
                name: 'refresh',
                hidden: true,
                component: {
                    beforeRouteEnter(to, from, next) {
                        next(instance => instance.$router.replace(from.fullPath));
                    },
                    render: h => h()
                }
            },
            // 页面重定向 必须保留
            {
                path: 'redirect/:route*',
                name: 'redirect',
                hidden: true,
                component: {
                    beforeRouteEnter(to, from, next) {
                        next(instance => instance.$router.replace(JSON.parse(from.params.route)));
                    },
                    render: h => h()
                }
            }
        ]
    },
    home,  // 首页
    // alliance,  // 联盟管理
    // chain, // 区块链管理
    chainmaker,
    // system,  // 系统管理
    setting,
    basic,
    FiscoBcos,
    carbon,
    super1,  // 超级管理员
    bcos,
    bcosChain,
    bcosContract,
    bcosSystem,
    bcosMonitor,
    bcosAudit,
    BcosEvent,
    report,  // 财务报表
];

/**
 * 在主框架之外显示
 */

const frameOut = [
    // 官网
    {
        path: '/',
        name: 'index',
        meta: {
            title: '$t:page.index.title'
        },
        component: () => import('@/pages/index')
    },
    // 登录
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '$t:page.login.title'
        },
        component: () => import('@/pages/account/login')
    },
    // 注册
    {
        path: '/register',
        name: 'register',
        meta: {
            title: '$t:page.register.title'
        },
        component: () => import('@/pages/account/register')
    },
    // 注册结果
    {
        path: '/register/result',
        name: 'register-result',
        meta: {
            auth: true,
            title: '注册结果'
        },
        component: () => import('@/pages/account/register/result')
    },
];

/**
 * 错误页面
 */

const errorPage = [
    {
        path: '/403',
        name: '403',
        meta: {
            title: '403'
        },
        component: () => import('@/pages/system/error/403')
    },
    {
        path: '/500',
        name: '500',
        meta: {
            title: '500'
        },
        component: () => import('@/pages/system/error/500')
    },
    {
        path: '*',
        name: '404',
        meta: {
            title: '404'
        },
        component: () => import('@/pages/system/error/404')
    }
];

// 导出需要显示菜单的
export const frameInRoutes = frameIn;

// 重新组织后导出
export default [
    ...frameIn,
    ...frameOut,
    ...errorPage
];
